import { CommonUtilsService } from 'util/services';
import { ActionService } from './actionService';
import { ClipboardServiceFactory } from './clipboardService';
import { DiscoveryDocumentService } from './discoveryDocumentService';
import { EnvironmentService } from './environmentService';
import { GroupItemsServiceFactory } from './groupItemsService';
import { ProgressService } from './progressService';
import { RegistrationService } from './registrationService';
import SettingsService from './settingsService';
import { UriPathServiceFactory } from './uriPathService';
import { UploadService } from './uploadService';
import { AuthServiceFactory } from './auth';
import { LocalizedResourcesService } from './localizedResourcesService';
import { commonUtilModule } from 'util/util';
import { AclService } from './aclService';
import { PhoenixToggleServiceProvider } from './phoenixToggleService';
import { DisplayMessageProvider } from './displayMessageService';
import { UploadItemFactory } from 'phoenix/factories/upload-item-factory';
import { UploadExceptionFactory } from 'phoenix/factories/upload-exception-factory';
import { LinkAuthExceptionFactory } from 'phoenix/factories/link-auth-exception-factory';
import { LinkCreationExceptionFactory } from 'phoenix/factories/link-creation-exception-factory';
import { TaskService } from './taskService';
import { FeatureService } from './featureService';
import { StaticToggleService } from 'util/services/staticToggleService';
import { DeploymentService } from './deploymentService';
import { eventSubscriptionServiceFactory } from './eventSubscriptionService';
import { EventRelayService } from './event-relay';
import { HostBridgeService } from './hostBridgeService';
import { DateService } from './date-service';

export * from './deploymentService';
export * from './aclService';
export * from './actionService';
export * from './auth';
export * from './date-service';
export * from './discoveryDocumentService';
export * from './phoenixToggleService';
export * from './registrationService';
export * from './taskService';
export * from './progressService';
export * from './uploadService';
export * from './uriPathService';
export * from './hostBridgeService';
export * from './featureService';
export * from './progressService';
export * from './environmentService';
export * from './localizedResourcesService';
export * from './displayMessageService';
export * from './eventSubscriptionService';
export * from 'phoenix/factories/link-auth-exception-factory';
export * from 'phoenix/factories/link-creation-exception-factory';

//  to support integration tests, don't overwrite the settings service 
// if it has already been loaded
export const settingsModule = CommonUtilsService
	.tryGetModule('site.settings')
	.service('settingsService',	SettingsService);

export const servicesModule = angular
	.module('phoenix.services', [
		'ngMaterial',
        'gettext',
		settingsModule.name,
		commonUtilModule.name
	])
	.service('pxDateService', DateService)
	.service('pxActionService', ActionService)
	.service('pxLocalizedResourcesService', LocalizedResourcesService)
	.service('pxDeploymentService', DeploymentService)
	.service('pxDiscoveryDocumentService', DiscoveryDocumentService)
	.service('pxProgressService', ProgressService)
	.factory('pxGroupItemsService', GroupItemsServiceFactory)
	.factory('pxClipboardService', ClipboardServiceFactory)
	.service('pxEnvironmentService', EnvironmentService)
	.service('pxRegistrationService', RegistrationService)
	.service('pxTaskService', TaskService)
	.factory('pxAuthService', AuthServiceFactory)
	.factory('pxUriPathService', UriPathServiceFactory)
	.provider('pxPhoenixToggleService', PhoenixToggleServiceProvider)
	.service('pxFeatureService', FeatureService)
	.service('pxUploadService', UploadService)
	.provider('pxDisplayMessageService', DisplayMessageProvider)
	.service('pxUploadExceptionFactory', UploadExceptionFactory)
	.service('pxUploadItemFactory', UploadItemFactory)
	.service('pxLinkAuthExceptionFactory', LinkAuthExceptionFactory)
	.service('pxLinkCreationExceptionFactory', LinkCreationExceptionFactory)
	.service('pxAclService', AclService)
	.service('pxHostBridgeService', HostBridgeService)
	.service('pxEventRelayService', EventRelayService)
	.factory('pxEventSubscriptionService', eventSubscriptionServiceFactory)
	.run([
		'settingsService', 
		'staticToggleService', 
		(settingsService:SettingsService, staticToggleService:StaticToggleService) => {
			settingsService.features.forEach(f => staticToggleService.add(f));
		}
	])
	.run([
		'$rootScope',
		'pxProgressService',
		($rootScope:ng.IRootScopeService, pxProgressService:ProgressService) => {
			$rootScope.$on('$stateChangeStart', () => {
				pxProgressService.hide(true);
			});
		}
	]);	



// WEBPACK FOOTER //
// ./src/phoenix/services/index.ts